__turbopack_context__.v({
  "text-shimmer": "text-shimmer-module__H5gOIW__text-shimmer",
  "textShimmer": "text-shimmer-module__H5gOIW__textShimmer",
});
